import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import PartnerProfile from './components/PartnerProfile';
import CredentialsSection from './components/CredentialsSection';
import FirmStorySection from './components/FirmStorySection';
import IndependenceStatement from './components/IndependenceStatement';
import ClientTestimonials from './components/ClientTestimonials';
import TeamMetrics from './components/TeamMetrics';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import { CALENDLY_LINK, CONTACT_PHONE, CONTACT_EMAIL } from '../../utils/constants';

const AboutPartnership = () => {
  const partners = [


    {
      id: 1,
      name: "Thomas Jasiak",
      title: "Partner & Lead Litigation Specialist",
      credentials: "CVA, CPA",
      bio: `Tom Jasiak is a seasoned financial professional based in Northeast Wyoming, combining deep expertise in accounting, economics, and financial planning to deliver insightful business valuations. As a Certified Public Accountant (CPA) and Certified Valuation Analyst (CVA), Tom leverages over 15 years of experience working closely with clients on complex tax strategies and financial planning. His academic foundation—a bachelor’s degree in economics from the University of Michigan and a master’s degree in accounting from Western Michigan University—equips him with a strong analytical framework for assessing business value. Tom’s unique blend of technical knowledge and client-focused advisory experience allows him to approach valuation engagements with a comprehensive understanding of both financial performance and strategic planning. Outside of work, Tom enjoys spending time with his family, volunteering in his community, exploring on a bicycle, fly fishing, and reading.`,
      // experience: 12,
      // courtAppearances: 28,
      // valuationsCompleted: 220,
      // specializations: ["Financial Reporting", "GAAP Compliance", "Startup Valuation", "IP Valuation"],
      image: "/img4 (1).jpg",
      linkedin: "https://www.linkedin.com/in/thomas-jasiak-755a40228/",
      email: "thomas.jasiak@northbridgevaluation.com",
      // location: "Gilette, Wyoming"
    },
    {
      id: 2,
      name: "Mahmood Al-Saati",
      title: "Partner & Lead Valuer",
      credentials: "CVA, FMVA, MBA",
      bio: `Mahmood is a seasoned management consultant, Certified Valuation Analyst (CVA) and Financial Modeling & Valuation Analyst (FMVA) with over 15 years of experience advising businesses and investors across the US, GCC, and beyond. He holds a bachelor’s degree in Aeronautical Engineering Technology from Purdue University and an MBA from Webster University in San Diego, bringing a disciplined technical and strategic lens to complex valuation challenges. As co-founder and lead valuer at Northbridge Valuation & Advisory, Mahmood specializes in business valuations, financial modeling, strategic planning, and investor-ready pitch decks that empower clients to secure funding, execute growth strategies, and navigate critical transactions. His commercial leadership at his previous roles driving revenue growth and key decisions combined with entrepreneurial experience founding and successfully exiting a precision manufacturing firm, has enabled him to support a wide spectrum of clients from early-stage startups raising pre-seed through later-stage rounds to mid-market companies, family offices, and large corporates pursuing expansions, acquisitions, restructurings, and exits. Outside of work, Mahmood enjoys family time, travel, and staying active through fitness and outdoor adventures.`,
      // experience: 12,
      // courtAppearances: 16,
      // valuationsCompleted: 280,
      // specializations: ["Business Valuation", "Litigation Support", "M&A Advisory", "Family Business Succession"],
      image: "/img3.jpg",
      linkedin: "https://www.linkedin.com/in/mahmood-alsaati/",
      email: "mahmood.alsaati@northbridgevaluation.com",
      // location: "Bahrain"
    },

  ];

  return (
    <>
      <Helmet>
        <title>About Us - Northbridge Valuation & Advisory</title>
        <meta name="description" content="Meet our CVA-certified partners with court-nominable qualifications and deep valuation expertise." />
        <meta name="keywords" content="CVA certified valuers, court expert witness, business valuation partners, litigation support specialists" />
        <link rel="canonical" href="/about" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />

        {/* Hero Section */}
        <section className="bg-gradient-to-br from-primary/5 to-accent/5 pt-8 pb-16">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-accent/10 rounded-full mb-6">
                <Icon name="Users" size={40} className="text-accent" />
              </div>

              <h1 className="text-4xl lg:text-5xl font-semibold text-text-primary mb-6">
                Meet Our Partnership
              </h1>

              <p className="text-xl text-text-secondary max-w-3xl mx-auto mb-8">
                CVA & CPA-certified experts providing independent valuation opinions, litigation support, and clear documentation built to withstand scrutiny.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button
                  variant="default"
                  size="lg"
                  iconName="Calendar"
                  iconPosition="left"
                  asChild
                >
                  <Link to="/book-consultation">
                    Free Consultation
                  </Link>
                </Button>
                {/* <Button
                  variant="outline"
                  size="lg"
                  iconName="Download"
                  iconPosition="left"
                >
                  Download Credentials
                </Button> */}
              </div>
            </div>
          </div>
        </section>

        {/* Partner Profiles */}
        <section className="py-16">
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-semibold text-text-primary mb-4">
                Our Leadership Team
              </h2>
              <p className="text-lg text-text-secondary max-w-3xl mx-auto">
                Experienced valuation specialists committed to rigorous methodology, independence, and clear, defensible conclusions.              </p>
            </div>

            <div className="grid lg:grid-cols-2 gap-8">
              {partners?.map((partner) => (
                <PartnerProfile key={partner?.id} partner={partner} />
              ))}
            </div>
          </div>
        </section>

        {/* Firm Story */}
        <FirmStorySection />

        {/* Credentials */}
        <CredentialsSection />

        {/* Team Metrics */}
        <TeamMetrics />

        {/* Independence Statement */}
        <IndependenceStatement />

        {/* Client Testimonials */}
        <ClientTestimonials />

        {/* CTA Section */}
        <section className="bg-primary text-white py-16">
          <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/10 rounded-full mb-6">
              <Icon name="Handshake" size={32} className="text-white" />
            </div>

            <h2 className="text-3xl font-semibold mb-4">
              Ready to Work with Certified Experts?
            </h2>

            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Experience the difference that CVA & CPA certification, court-nominable status, and deep expertise make in your valuation needs.            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                variant="secondary"
                size="lg"
                iconName="Phone"
                iconPosition="left"
                asChild
              >
                <a href={`tel:${CONTACT_PHONE}`}>Call {CONTACT_PHONE}</a>
              </Button>
              <Button
                variant="outline"
                size="lg"
                className="border-white text-white hover:bg-white hover:text-primary"
                iconName="Mail"
                iconPosition="left"
                asChild
              >
                <a href={`mailto:${CONTACT_EMAIL}`}>Email Us</a>
              </Button>
            </div>

            <div className="mt-8 pt-8 border-t border-white/20">
              <p className="text-sm text-white/80">
                All consultations are confidential and covered by professional privilege
              </p>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
};

export default AboutPartnership;